<mat-drawer-container class="side-menu-wrapper mat-elevation-z0" autosize>
  <mat-drawer #drawer mode="side" disableClose="true" [opened]="!mobileQuery?.matches">
    <styles-menu-label>{{ appVersion }}</styles-menu-label>
    <styles-menu-wrapper>
      <!-- My  Module -->
      <styles-menu-header
        caption="Home"
        icon="home"
        route="/my/overview"
        [allowedRoutes]="['/my' , '/team']"
        [children]="homeChildrenQuery"
        #home
      >
      </styles-menu-header>

      <styles-menu-item
        caption="My Tasks"
        icon="task"
        selectedRoutePattern="/my/tasks"
        routerLink="/my/tasks"
        routerLinkActive="active"
        [visable]="home.expanded"
        [queryList]="homeChildrenQuery"
        #homeChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="My Calendar"
        icon="event"
        selectedRoutePattern="/my/calendar"
        routerLink="/my/calendar"
        routerLinkActive="active"
        [queryList]="homeChildrenQuery"
        [visable]="home.expanded"
        #homeChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="My Kanban"
        icon="thumbs_up_down"
        selectedRoutePattern="/my/kanban"
        routerLink="/my/kanban"
        routerLinkActive="active"
        [visable]="home.expanded"
        [queryList]="homeChildrenQuery"
        #homeChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="My Team"
        icon="people"
        [selectedRoutePattern]="'/team/' + auth.departmentId"
        [routerLink]="'/team/' + auth.departmentId"
        routerLinkActive="active"
        [visable]="home.expanded"
        [queryList]="homeChildrenQuery"
        #homeChildren
      >
      </styles-menu-item>

      <!-- Projects Module -->
      <styles-menu-header
        caption="Projects"
        icon="dataset"
        route="/projects/projects-list"
        [allowedRoutes]="['/projects/projects-list','/projects/plans-list','/projects/productions-list','/projects/publish-list','/projects/projects-archive']"
        [children]="projectsChildrenQuery"
        #projects
      >
      </styles-menu-header>

      <!-- Organization Module -->
      <styles-menu-header
        caption="Organizations"
        icon="corporate_fare"
        route="/orgs"
        [allowedRoutes]="['/orgs']"
        [children]="organizationChildrenQuery"
        #org
      >
      </styles-menu-header>

      <!-- Content Module -->
      <styles-menu-header
        caption="Content"
        icon="picture_in_picture"
        route="/content"
        [allowedRoutes]="['/content']"
        [children]="contentChildrenQuery"
        #org
      >
      </styles-menu-header>

      <!-- Sow Module -->
      <styles-menu-header
        caption="Sows"
        icon="receipt"
        route="/sows"
        [allowedRoutes]="['/sows']"
        [children]="organizationChildrenQuery"
        #org
      >
      </styles-menu-header>

      <!-- Campaigns Module -->
      <styles-menu-header
        caption="Campaigns"
        icon="campaign"
        route="/campaigns"
        [allowedRoutes]="['/campaigns']"
        [children]="organizationChildrenQuery"
        #org
      >
      </styles-menu-header>
    </styles-menu-wrapper>

    <styles-menu-label>Departments</styles-menu-label>
    <styles-menu-wrapper>
      <!-- Editorial Menu -->
      <styles-menu-header
        caption="Editorial"
        icon="create"
        [allowedRoutes]="['/team/11/projects' , '/team/11/tasks', '/team/11/']"
        [children]="editorialMenuChildrenQuery"
        #editorialMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/11/overview"
        [routerLink]="['/team/11/overview']"
        routerLinkActive="active"
        [visable]="editorialMenu.expanded"
        [queryList]="editorialMenuChildrenQuery"
        #editorialMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/11/projects"
        [routerLink]="['/team/11/projects']"
        routerLinkActive="active"
        [visable]="editorialMenu.expanded"
        [queryList]="editorialMenuChildrenQuery"
        #editorialMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/11/tasks"
        [routerLink]="['/team/11/tasks']"
        routerLinkActive="active"
        [visable]="editorialMenu.expanded"
        [queryList]="editorialMenuChildrenQuery"
        #editorialMenuChildren
      >
      </styles-menu-item>

      <!-- Design Menu -->
      <styles-menu-header
        caption="Design"
        icon="image"
        [allowedRoutes]="['/team/15/projects' , '/team/15/tasks', '/team/15/']"
        [children]="designMenuChildrenQuery"
        #designMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/15/overview"
        [routerLink]="['/team/15/overview']"
        routerLinkActive="active"
        [visable]="designMenu.expanded"
        [queryList]="designMenuChildrenQuery"
        #designMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/15/projects"
        [routerLink]="['/team/15/projects']"
        routerLinkActive="active"
        [visable]="designMenu.expanded"
        [queryList]="designMenuChildrenQuery"
        #designMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/15/tasks"
        [routerLink]="['/team/15/tasks']"
        routerLinkActive="active"
        [visable]="designMenu.expanded"
        [queryList]="designMenuChildrenQuery"
        #designMenuChildren
      >
      </styles-menu-item>

      <!-- Video Menu -->
      <styles-menu-header
        caption="Video"
        icon="movie"
        [allowedRoutes]="['/team/16/projects' , '/team/16/tasks', '/team/16/']"
        [children]="videoMenuChildrenQuery"
        #videoMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/16/overview"
        [routerLink]="['/team/16/overview']"
        routerLinkActive="active"
        [visable]="videoMenu.expanded"
        [queryList]="videoMenuChildrenQuery"
        #videoMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/16/projects"
        [routerLink]="['/team/16/projects']"
        routerLinkActive="active"
        [visable]="videoMenu.expanded"
        [queryList]="videoMenuChildrenQuery"
        #videoMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/16/tasks"
        [routerLink]="['/team/16/tasks']"
        routerLinkActive="active"
        [visable]="videoMenu.expanded"
        [queryList]="videoMenuChildrenQuery"
        #videoMenuChildren
      >
      </styles-menu-item>

      <!-- Social Menu -->
      <styles-menu-header
        caption="Social"
        icon="share"
        [allowedRoutes]="['/team/2226/projects' , '/team/2226/tasks', '/team/2226/']"
        [children]="socialMenuChildrenQuery"
        #socialMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2226/overview"
        [routerLink]="['/team/2226/overview']"
        routerLinkActive="active"
        [visable]="socialMenu.expanded"
        [queryList]="socialMenuChildrenQuery"
        #socialMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2226/projects"
        [routerLink]="['/team/2226/projects']"
        routerLinkActive="active"
        [visable]="socialMenu.expanded"
        [queryList]="socialMenuChildrenQuery"
        #socialMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2226/tasks"
        [routerLink]="['/team/2226/tasks']"
        routerLinkActive="active"
        [visable]="socialMenu.expanded"
        [queryList]="socialMenuChildrenQuery"
        #socialMenuChildren
      >
      </styles-menu-item>

      <!-- Consulting Menu -->
      <styles-menu-header
        caption="Consulting"
        icon="monitoring"
        [allowedRoutes]="['/team/18/projects' , '/team/18/tasks', '/team/18/']"
        [children]="consultingMenuChildrenQuery"
        #consultingMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/18/overview"
        [routerLink]="['/team/18/overview']"
        routerLinkActive="active"
        [visable]="consultingMenu.expanded"
        [queryList]="consultingMenuChildrenQuery"
        #consultingMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/18/projects"
        [routerLink]="['/team/18/projects']"
        routerLinkActive="active"
        [visable]="consultingMenu.expanded"
        [queryList]="consultingMenuChildrenQuery"
        #consultingMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/18/tasks"
        [routerLink]="['/team/18/tasks']"
        routerLinkActive="active"
        [visable]="consultingMenu.expanded"
        [queryList]="consultingMenuChildrenQuery"
        #consultingMenuChildren
      >
      </styles-menu-item>

      <!-- Tech Menu -->
      <styles-menu-header
        caption="Tech"
        icon="keyboard"
        [allowedRoutes]="['/team/10/projects' , '/team/10/tasks', '/team/10/']"
        [children]="techMenuChildrenQuery"
        #techMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/10/overview"
        [routerLink]="['/team/10/overview']"
        routerLinkActive="active"
        [visable]="techMenu.expanded"
        [queryList]="techMenuChildrenQuery"
        #techMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/10/projects"
        [routerLink]="['/team/10/projects']"
        routerLinkActive="active"
        [visable]="techMenu.expanded"
        [queryList]="techMenuChildrenQuery"
        #techMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/10/tasks"
        [routerLink]="['/team/10/tasks']"
        routerLinkActive="active"
        [visable]="techMenu.expanded"
        [queryList]="techMenuChildrenQuery"
        #techMenuChildren
      >
      </styles-menu-item>

      <!-- Data Processing Team Menu -->
      <styles-menu-header
        caption="Data Processing"
        icon="account_tree"
        [allowedRoutes]="['/team/2272/projects' , '/team/2272/tasks', '/team/2272/']"
        [children]="dataProcessingMenuChildrenQuery"
        #dataProcessingMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2272/overview"
        [routerLink]="['/team/2272/overview']"
        routerLinkActive="active"
        [visable]="dataProcessingMenu.expanded"
        [queryList]="dataProcessingMenuChildrenQuery"
        #dataProcessingMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2272/projects"
        [routerLink]="['/team/2272/projects']"
        routerLinkActive="active"
        [visable]="dataProcessingMenu.expanded"
        [queryList]="dataProcessingMenuChildrenQuery"
        #dataProcessingMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2272/tasks"
        [routerLink]="['/team/2272/tasks']"
        routerLinkActive="active"
        [visable]="dataProcessingMenu.expanded"
        [queryList]="dataProcessingMenuChildrenQuery"
        #dataProcessingMenuChildren
      >
      </styles-menu-item>

      <!-- Email Menu -->
      <styles-menu-header
        caption="Email"
        icon="mail"
        [allowedRoutes]="['/team/2257/projects' , '/team/2257/tasks', '/team/2257/']"
        [children]="emailMenuChildrenQuery"
        #emailMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2257/overview"
        [routerLink]="['/team/2257/overview']"
        routerLinkActive="active"
        [visable]="emailMenu.expanded"
        [queryList]="emailMenuChildrenQuery"
        #emailMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2257/projects"
        [routerLink]="['/team/2257/projects']"
        routerLinkActive="active"
        [visable]="emailMenu.expanded"
        [queryList]="emailMenuChildrenQuery"
        #emailMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2257/tasks"
        [routerLink]="['/team/2257/tasks']"
        routerLinkActive="active"
        [visable]="emailMenu.expanded"
        [queryList]="emailMenuChildrenQuery"
        #emailMenuChildren
      >
      </styles-menu-item>

      <!-- PPC Menu -->
      <styles-menu-header
        caption="PPC"
        icon="ads_click"
        [allowedRoutes]="['/team/2258/projects' , '/team/2258/tasks', '/team/2258/']"
        [children]="ppcMenuChildrenQuery"
        #ppcMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2258/overview"
        [routerLink]="['/team/2258/overview']"
        routerLinkActive="active"
        [visable]="ppcMenu.expanded"
        [queryList]="ppcMenuChildrenQuery"
        #ppcMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2258/projects"
        [routerLink]="['/team/2258/projects']"
        routerLinkActive="active"
        [visable]="ppcMenu.expanded"
        [queryList]="ppcMenuChildrenQuery"
        #ppcMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2258/tasks"
        [routerLink]="['/team/2258/tasks']"
        routerLinkActive="active"
        [visable]="ppcMenu.expanded"
        [queryList]="ppcMenuChildrenQuery"
        #ppcMenuChildren
      >
      </styles-menu-item>

      <!-- SEO Menu -->
      <styles-menu-header
        caption="SEO"
        icon="http"
        [allowedRoutes]="['/team/2267/projects' , '/team/2267/tasks', '/team/2267/']"
        [children]="seoMenuChildrenQuery"
        #seoMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2267/overview"
        [routerLink]="['/team/2267/overview']"
        routerLinkActive="active"
        [visable]="seoMenu.expanded"
        [queryList]="seoMenuChildrenQuery"
        #seoMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2267/projects"
        [routerLink]="['/team/2267/projects']"
        routerLinkActive="active"
        [visable]="seoMenu.expanded"
        [queryList]="seoMenuChildrenQuery"
        #seoMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2267/tasks"
        [routerLink]="['/team/2267/tasks']"
        routerLinkActive="active"
        [visable]="seoMenu.expanded"
        [queryList]="seoMenuChildrenQuery"
        #seoMenuChildren
      >
      </styles-menu-item>

      <!-- UX Menu -->
      <styles-menu-header
        caption="UX"
        icon="create"
        [allowedRoutes]="['/team/2259/projects' , '/team/2259/tasks', '/team/2259/']"
        [children]="uxMenuChildrenQuery"
        #uxMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2259/overview"
        [routerLink]="['/team/2259/overview']"
        routerLinkActive="active"
        [visable]="uxMenu.expanded"
        [queryList]="uxMenuChildrenQuery"
        #uxMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2259/projects"
        [routerLink]="['/team/2259/projects']"
        routerLinkActive="active"
        [visable]="uxMenu.expanded"
        [queryList]="uxMenuChildrenQuery"
        #uxMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2259/tasks"
        [routerLink]="['/team/2259/tasks']"
        routerLinkActive="active"
        [visable]="uxMenu.expanded"
        [queryList]="uxMenuChildrenQuery"
        #uxMenuChildren
      >
      </styles-menu-item>

      <!-- Sales Ops Menu -->
      <styles-menu-header
        caption="Sales Ops"
        icon="paid"
        [allowedRoutes]="['/team/2266/projects' , '/team/2266/tasks', '/team/2266/']"
        [children]="salesOpsMenuChildrenQuery"
        #salesOpsMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2266/overview"
        [routerLink]="['/team/2266/overview']"
        routerLinkActive="active"
        [visable]="salesOpsMenu.expanded"
        [queryList]="salesOpsMenuChildrenQuery"
        #salesOpsMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2266/projects"
        [routerLink]="['/team/2266/projects']"
        routerLinkActive="active"
        [visable]="salesOpsMenu.expanded"
        [queryList]="salesOpsMenuChildrenQuery"
        #salesOpsMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2266/tasks"
        [routerLink]="['/team/2266/tasks']"
        routerLinkActive="active"
        [visable]="salesOpsMenu.expanded"
        [queryList]="salesOpsMenuChildrenQuery"
        #salesOpsMenuChildren
      >
      </styles-menu-item>

      <!-- Project Management Menu -->
      <styles-menu-header
        caption="Project Management"
        icon="people"
        [allowedRoutes]="['/team/19/projects' , '/team/19/tasks', '/team/19/']"
        [children]="projectManagementMenuChildrenQuery"
        #projectManagementMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/19/overview"
        [routerLink]="['/team/19/overview']"
        routerLinkActive="active"
        [visable]="projectManagementMenu.expanded"
        [queryList]="projectManagementMenuChildrenQuery"
        #projectManagementMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/19/projects"
        [routerLink]="['/team/19/projects']"
        routerLinkActive="active"
        [visable]="projectManagementMenu.expanded"
        [queryList]="projectManagementMenuChildrenQuery"
        #projectManagementMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/19/tasks"
        [routerLink]="['/team/19/tasks']"
        routerLinkActive="active"
        [visable]="projectManagementMenu.expanded"
        [queryList]="projectManagementMenuChildrenQuery"
        #projectManagementMenuChildren
      >
      </styles-menu-item>

      <!-- Account Management Menu -->
      <styles-menu-header
        caption="Account Management"
        icon="contact_mail"
        [allowedRoutes]="['/team/2197/projects' , '/team/2197/tasks', '/team/2197/']"
        [children]="accountManagementMenuChildrenQuery"
        #accountManagementMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2197/overview"
        [routerLink]="['/team/2197/overview']"
        routerLinkActive="active"
        [visable]="accountManagementMenu.expanded"
        [queryList]="accountManagementMenuChildrenQuery"
        #accountManagementMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2197/projects"
        [routerLink]="['/team/2197/projects']"
        routerLinkActive="active"
        [visable]="accountManagementMenu.expanded"
        [queryList]="accountManagementMenuChildrenQuery"
        #accountManagementMenuChildren
      >
      </styles-menu-item>

      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2197/tasks"
        [routerLink]="['/team/2197/tasks']"
        routerLinkActive="active"
        [visable]="accountManagementMenu.expanded"
        [queryList]="accountManagementMenuChildrenQuery"
        #accountManagementMenuChildren
      >
      </styles-menu-item>

      <!-- Sales Menu -->
      <styles-menu-header
        caption="Sales"
        icon="add_card"
        [allowedRoutes]="['/team/2206/projects' , '/team/2206/tasks', '/team/2206/']"
        [children]="salesMenuChildrenQuery"
        #salesMenu
      >
      </styles-menu-header>

      <styles-menu-item
        caption="Team"
        icon="groups"
        selectedRoutePattern="/team/2206/overview"
        [routerLink]="['/team/2206/overview']"
        routerLinkActive="active"
        [visable]="salesMenu.expanded"
        [queryList]="salesMenuChildrenQuery"
        #salesMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Projects"
        icon="dataset"
        selectedRoutePattern="/team/2206/projects"
        [routerLink]="['/team/2206/projects']"
        routerLinkActive="active"
        [visable]="salesMenu.expanded"
        [queryList]="salesMenuChildrenQuery"
        #salesMenuChildren
      >
      </styles-menu-item>
      <styles-menu-item
        caption="Tasks"
        icon="task"
        selectedRoutePattern="/team/2206/tasks"
        [routerLink]="['/team/2206/tasks']"
        routerLinkActive="active"
        [visable]="salesMenu.expanded"
        [queryList]="salesMenuChildrenQuery"
        #salesMenuChildren
      >
      </styles-menu-item>

      <!-- <ng-container *ngTemplateOutlet="teamMenu"> </ng-container> -->
    </styles-menu-wrapper>
  </mat-drawer>

  <!-- Main Page Content -->
  <mat-drawer-content>
    <ng-content select="[page-content]"></ng-content>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #teamMenu let-name="name" let-icon="icon" let-id="id" let-childrenQuery="childrenQuery">
  <styles-menu-header
    [caption]="name"
    [icon]="icon"
    [allowedRoutes]="['/team/' + id.toString() + '/projects' , '/team/' + id.toString() + '/tasks', '/team/' + id.toString() + '/']"
    [children]="salesOpsMenuChildrenQuery"
    #salesOpsMenu
  >
  </styles-menu-header>

  <styles-menu-item
    caption="Team"
    icon="groups"
    [selectedRoutePattern]="'/team/' + id.toString() + '/overview'"
    [routerLink]="['/team/' + id.toString() + '/overview']"
    routerLinkActive="active"
    [visable]="salesOpsMenu.expanded"
    [queryList]="salesOpsMenuChildrenQuery"
    #salesOpsMenuChildren
  >
  </styles-menu-item>
  <styles-menu-item
    caption="Projects"
    icon="dataset"
    [selectedRoutePattern]="'/team/' + id.toString() + '/projects'"
    [routerLink]="['/team/' + id.toString() + '/projects']"
    routerLinkActive="active"
    [visable]="salesOpsMenu.expanded"
    [queryList]="salesOpsMenuChildrenQuery"
    #salesOpsMenuChildren
  >
  </styles-menu-item>

  <styles-menu-item
    caption="Tasks"
    icon="task"
    [selectedRoutePattern]="'/team/' + id.toString() + '/tasks'"
    [routerLink]="['/team/' + id.toString() + '/tasks']"
    routerLinkActive="active"
    [visable]="salesOpsMenu.expanded"
    [queryList]="salesOpsMenuChildrenQuery"
    #salesOpsMenuChildren
  >
  </styles-menu-item>
</ng-template>
